<!--<app-developer-artifact-assembly-picker></app-developer-artifact-assembly-picker>-->
<app-developer-artifact-assembly-picker [selectedArtifactId]="datafield.Value" (selectedArtifactIdChange)="setValue($event)" [assemblyTypes]="datafield.AdditionalInfo"></app-developer-artifact-assembly-picker>
@if (!isValid) {
  <div class="error">This field is required</div>
}
